import { FC, useEffect } from "react";
import { NavbarContentProps } from "./types";
import { useNavStore, useThemeStore } from "../../../stores";
import { useResponsive } from "../../../hooks";
import Nav from "./nav";

const NavbarContent: FC<NavbarContentProps> = () => {
  const theme = useThemeStore((state) => state.theme);
  const isMobile = useResponsive();
  const { openNav, closeNav, navWidth, setNavWidth } = useNavStore();

  useEffect(() => {
    setNavWidth(!isMobile ? 96 : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  return (
    <div
      style={{
        height: "100vh",
        background: theme.overlay,
        position: "absolute",
        top: 0,
        right: 0,
        width: navWidth,
        zIndex: 10,
        overflow: "hidden",
      }}
      className="transition"
      onMouseEnter={!isMobile ? openNav : () => {}}
      onMouseLeave={!isMobile ? closeNav : () => {}}
    >
      <Nav />
    </div>
  );
};

export default NavbarContent;
